import {createCookie} from "./create-cookie.ts";
import {formatFlagsCookie} from "./format-flags-cookie.ts";
import {queryParamsToFeatureFlags} from "./query-params-to-feature-flags.ts";
import {CookieCategory} from "./types.ts";

/**
 * Update the flags cookie based on URL query parameters.
 *
 * This function takes in a record of query parameters and constructs a
 * cookie that represents the feature flags to be enabled or disabled.
 * The flags are expected to be provided in the query parameters as
 * comma-separated values under the keys "flags_on" and "flags_off".
 *
 * If there are no flags specified by the params, this will NOT clear
 * an existing cookie.
 *
 * @param queryParams key-value pairs parsed from the URL.
 */
export function updateFlagsCookieFromURL(queryParams: URLSearchParams): void {
    const featureFlags = queryParamsToFeatureFlags(queryParams);
    const cookie = formatFlagsCookie(featureFlags);
    // Only set the cookie if there are flags to set.
    if (cookie) {
        createCookie("flags", CookieCategory.Functional, cookie, 365);
    }
}
